<template>
    <div class="tabs">
        <div class="tabs__tab">
             <router-link :to="{ name: 'Agents' }">
                <SvgIcon class="tabs__icon" iconName="ico-agent"/>
                Agents
                <span>(<span>{{ usersNumberAgents ? usersNumberAgents.totalAgents : 0 }}</span>)</span>
            </router-link>
        </div>
        <div class="tabs__tab">
            <router-link :to="{ name: 'Admins' }">
                <SvgIcon class="tabs__icon" iconName="ico-profile"/>
                Admins
                <span>(<span>{{ usersNumberAdmins ? usersNumberAdmins.totalAdmins : 0 }}</span>)</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	data() {
		return {
			activeTab: true
		};
	},
	components: {
		SvgIcon
	},
	computed: {
		usersNumberAgents() {
			return this.$store.getters.getUsersNumberFromAgents;
		},
		usersNumberAdmins() {
			return this.$store.getters.getUsersNumberFromAdmins;
		}
	}
};
</script>

<style lang="scss" scoped>
.tabs {
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid rgba($slate-gray, .4);
    margin-bottom: 30px;
    margin-top: 2px;
}

.tabs__icon {
    font-size: 12px;
    padding-right: 5px;
}

.tabs__tab {
    max-width: 50%;
    width: 100%;
    text-align: center;
    font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: $dodger-blue;
	transition: $dur $ease;
	text-decoration: none;
    border-right: 1px solid rgba($slate-gray, .4);

    &:last-of-type {
        border-right: none;
    }

    @include hover {
        a {
            color: $shuttle-gray;
            text-decoration: none;
        }
	}

    a {
        display: block;
        width: 100%;
        padding: 13px;
        transition: $dur $ease;
        background-color: $white-lilac;
        color: $shuttle-gray;

        &.is-active {
            color: $dodger-blue;
            background-color: $white-lilac;
        }
    }
}
</style>
